<template>
  <div class="security-dialog">
    <el-dialog
      :visible.sync="dialogVisible"
      :title="$t(title)"
      width="550px"
      top="30vh"
      :show-close="true"
    >
      <div class="txt" v-html="$t(content)"></div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleCancel">{{ $t('clientele_cancel') }}</el-button>
        <el-button size="small" type="primary" @click="handleConfirm">{{
          $t(confirmBtn)
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String
      },
      content: {
        type: String
      },
      panelType: {
        type: String
      }
    },
    data() {
      return {
        dialogVisible: false
      }
    },
    computed: {
      confirmBtn() {
        let type = 'confirm'
        if (this.panelType) {
          switch (this.panelType) {
            case 'googlecontact':
              type = 'free_googlecontact_config'
              break
            case 'outlookcontact':
              type = 'free_outlookcontact_config'
              break
            case 'crm':
              type = 'remove_binding'
              break
          }
        }
        return type
      }
    },
    methods: {
      changeLayerVisible() {
        this.dialogVisible = !this.dialogVisible
      },
      handleCancel() {
        this.dialogVisible = !this.dialogVisible
      },
      handleConfirm() {
        this.dialogVisible = !this.dialogVisible
        this.$emit('del')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .security-dialog {
    .dialog-content {
      .txt {
        font-size: 14px;
        line-height: 20px;
        word-wrap: break-word;
        overflow: hidden;
        text-align: center;
      }
    }
    ::v-deep .el-dialog {
      min-height: 170px;
    }

    ::v-deep .el-button {
      min-width: 100px;
    }
  }
</style>
